(function () {
	// Clicking an open row closes it again. The original only ever opened a row,
	// and it addressed panels by sibling index, which breaks as soon as the
	// markup around them changes -- the panel is found within its own row now.
	// The namespaced handler is detached first because this runs again on
	// shopify:section:load.
	const initProductAccordion = () => {
		$(".product__additional")
			.off("click.pdpAccordion")
			.on("click.pdpAccordion", function () {
				const $row = $(this);
				const $panel = $row.find(".product__additional-description");
				
				if ($row.hasClass("active")) {
					$row.removeClass("active");
					$panel.stop(true, true).slideUp(250);
					return;
				}
				
				$(".product__additional.active")
					.removeClass("active")
					.find(".product__additional-description")
					.stop(true, true)
					.slideUp(250);
				
				$row.addClass("active");
				$panel.stop(true, true).slideDown(300);
			});
	};

	document.addEventListener("shopify:section:load", function () {
		$(".product-section .product__media-list").flickity({
			pageDots: false,
			prevNextButtons: false,
			adaptiveHeight: true,
			wrapAround: true,
			on: {
				select: function (index) {
					console.log('On Flickity Select');
					let slides = $(".product-section .product__media-list .product__media-item");

					var iframe = $(slides[index]).find("iframe");

					var allIframes = document.querySelectorAll(".product-section .product__media-list iframe");
					//var allIframes = $(".product-section .product__media-list").find("iframe");
					var video = $(slides[index]).find("video");
					var allVideos = $(".product-section .product__media-list").find("video");

					if (video && video.length > 0) {
						video.get(0).play();
					} else if (allVideos && allVideos.length > 0) {
						allVideos.get(0).pause();
					}

					if (iframe && iframe.length > 0) {
						if (iframe[0].classList.contains('js-youtube')) {
							iframe[0].contentWindow.postMessage(
								JSON.stringify({ event: "command", func: "playVideo" }),
								"*",
							);
						}
						else {
							iframe[0].contentWindow.postMessage('{"method":"play"}', "*");
						}
					} else if (allIframes && allIframes.length > 0) {
						allIframes.forEach(video => {
							if (video.classList.contains('js-youtube')) {
								video.contentWindow.postMessage(
									JSON.stringify({ event: "command", func: "pauseVideo" }),
									"*",
								);
							}
							else {
								video.contentWindow.postMessage('{"method":"pause"}', "*");
							}
						})
					} else {
						return false;
					}
				},
			},
		});

		$(".product-section .product__media-sublist").flickity({
			asNavFor: ".product-section .product__media-list",
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			cellAlign: "left",
		});

		initProductAccordion();
		initModal("fancy-container-info");
	});

	initModal("fancy-container-info");
	initProductAccordion();
})();
